import { Container, Grid, Stack } from '@mui/material';
import { useEffect } from 'react';
import { FixNavbarSpace } from '../Utilities/Navbar';

const DealerCreditApplication = () => {
  useEffect(() => {
    const loadScript = (id: string, src: string, onLoad?: () => void) => {
      if (!document.getElementById(id)) {
        const script = document.createElement('script');
        script.id = id;
        script.src = src;
        script.type = 'text/javascript';
        script.onload = onLoad || null;
        document.body.appendChild(script);
      } else if (onLoad) {
        onLoad();
      }
    };

    loadScript('jotform-feedback2', 'https://form.jotform.com/static/feedback2.js', () => {
      if (window && 'JotformFeedback' in window) {
        // @ts-ignore
        if (!window.JFL_251268648062259) {
          // @ts-ignore
          window.JFL_251268648062259 = new window.JotformFeedback({
            formId: '251268648062259',
            base: 'https://form.jotform.com/',
            windowTitle: 'Business Credit Application Form',
            backgroundColor: '#5db158',
            fontColor: '#FFFFFF',
            type: 'false',
            height: 1000,
            width: 800,
            openOnLoad: false
          });
        }

        // Simular clic automático para abrir el formulario al cargar
        setTimeout(() => {
          const trigger = document.querySelector('.lightbox-251268648062259.auto') as HTMLElement;
          if (trigger) trigger.click();
        }, 500);
      }
    });

    loadScript('jotform-embed-handler', 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js');
  }, []);

  return (
    <Stack minHeight="60vh" alignItems="center" spacing={2}>
      <FixNavbarSpace />
      <Container>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={8} style={{ textAlign: 'center' }}>
            <h2>Business Credit Application</h2>
            <p>The form will open automatically. You can also reopen it using the button below.</p>

            {/* Botón oculto para la apertura automática */}
            <a
              className="lightbox-251268648062259 auto"
              style={{ display: 'none' }}
              href="#"
            >
              Hidden Trigger
            </a>

            {/* Botón visible para que el usuario lo use */}
            <a
              className="btn lightbox-251268648062259"
              style={{
                marginTop: '16px',
                textTransform: 'uppercase',
                fontSize: '14px',
                textDecoration: 'none',
                cursor: 'pointer',
                display: 'inline-block',
                padding: '10px',
                fontFamily: 'inherit',
                textShadow: 'none',
                userSelect: 'none',
                transition: 'all .1s ease-in',
                backgroundColor: '#5db158',
                border: '1px solid #5db158',
                color: '#FFFFFF'
              }}
              href="#"
            >
              Business Credit Application Form
            </a>
          </Grid>
        </Grid>
      </Container>
    </Stack>
  );
};

export default DealerCreditApplication;




